module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/avatars/male-4-2ae696983088274ad98997dc022a5f3a.jpg";